"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.icons = void 0;

var _alert = _interopRequireDefault(require("./assets/alert.svg"));

var _appStore = _interopRequireDefault(require("./assets/app-store.svg"));

var _boardingService = _interopRequireDefault(require("./assets/boarding-service.svg"));

var _bulletGreen = _interopRequireDefault(require("./assets/bullet-green.svg"));

var _boneGray = _interopRequireDefault(require("./assets/bone-gray.svg"));

var _calendar = _interopRequireDefault(require("./assets/calendar.svg"));

var _calendarGray = _interopRequireDefault(require("./assets/calendar-gray.svg"));

var _calendarGreen = _interopRequireDefault(require("./assets/calendar-green.svg"));

var _camera = _interopRequireDefault(require("./assets/camera.svg"));

var _car = _interopRequireDefault(require("./assets/car.svg"));

var _caret = _interopRequireDefault(require("./assets/caret.svg"));

var _caretDownGray = _interopRequireDefault(require("./assets/caret-down-gray.svg"));

var _caretDownGreen = _interopRequireDefault(require("./assets/caret-down-green.svg"));

var _caretRightGray = _interopRequireDefault(require("./assets/caret-right-gray.svg"));

var _check = _interopRequireDefault(require("./assets/check.svg"));

var _checkmark = _interopRequireDefault(require("./assets/checkmark.png"));

var _checkmarkGreen = _interopRequireDefault(require("./assets/checkmark-green.svg"));

var _clockGray = _interopRequireDefault(require("./assets/clock-gray.svg"));

var _collar = _interopRequireDefault(require("./assets/collar.svg"));

var _creditCard = _interopRequireDefault(require("./assets/credit-card.svg"));

var _daycareService = _interopRequireDefault(require("./assets/daycare-service.svg"));

var _caretDisabled = _interopRequireDefault(require("./assets/caret-disabled.svg"));

var _checkDisabled = _interopRequireDefault(require("./assets/check-disabled.svg"));

var _dog = _interopRequireDefault(require("./assets/dog.svg"));

var _dogAvatar = _interopRequireDefault(require("./assets/dog-avatar.svg"));

var _dogFaceGray = _interopRequireDefault(require("./assets/dog-face-gray.svg"));

var _dogGreen = _interopRequireDefault(require("./assets/dog-green.svg"));

var _dogSilhouetteGray = _interopRequireDefault(require("./assets/dog-silhouette-gray.svg"));

var _dollarSignGray = _interopRequireDefault(require("./assets/dollar-sign-gray.svg"));

var _email = _interopRequireDefault(require("./assets/email.svg"));

var _envelope = _interopRequireDefault(require("./assets/envelope.svg"));

var _exitGray = _interopRequireDefault(require("./assets/exit-gray.svg"));

var _eyeball = _interopRequireDefault(require("./assets/eyeball.png"));

var _facebook = _interopRequireDefault(require("./assets/facebook.svg"));

var _flyer = _interopRequireDefault(require("./assets/flyer.svg"));

var _googlePlay = _interopRequireDefault(require("./assets/google-play.svg"));

var _hamburger = _interopRequireDefault(require("./assets/hamburger.svg"));

var _home = _interopRequireDefault(require("./assets/home.svg"));

var _house = _interopRequireDefault(require("./assets/house.svg"));

var _houseGreen = _interopRequireDefault(require("./assets/house-green.svg"));

var _imageGray = _interopRequireDefault(require("./assets/image-gray.svg"));

var _infoGreen = _interopRequireDefault(require("./assets/info-green.svg"));

var _infoWhite = _interopRequireDefault(require("./assets/info-white.svg"));

var _instagram = _interopRequireDefault(require("./assets/instagram.svg"));

var _key = _interopRequireDefault(require("./assets/key.svg"));

var _lock = _interopRequireDefault(require("./assets/lock.svg"));

var _lockGray = _interopRequireDefault(require("./assets/lock-gray.svg"));

var _medicalGray = _interopRequireDefault(require("./assets/medical-gray.svg"));

var _noteGray = _interopRequireDefault(require("./assets/note-gray.svg"));

var _overnightService = _interopRequireDefault(require("./assets/overnight-service.svg"));

var _pageNote = _interopRequireDefault(require("./assets/page-note.svg"));

var _pawPrint = _interopRequireDefault(require("./assets/paw-print.svg"));

var _pawPrintPinGray = _interopRequireDefault(require("./assets/paw-print-pin-gray.svg"));

var _paymentGray = _interopRequireDefault(require("./assets/payment-gray.svg"));

var _pencil = _interopRequireDefault(require("./assets/pencil.svg"));

var _pencilGreen = _interopRequireDefault(require("./assets/pencil-green.svg"));

var _phone = _interopRequireDefault(require("./assets/phone.svg"));

var _phoneCall = _interopRequireDefault(require("./assets/phone-call.svg"));

var _plusGreen = _interopRequireDefault(require("./assets/plus-green.svg"));

var _silhouette = _interopRequireDefault(require("./assets/silhouette.svg"));

var _silhouetteGirl = _interopRequireDefault(require("./assets/silhouette-girl1.svg"));

var _silhouetteGirl2 = _interopRequireDefault(require("./assets/silhouette-girl2.svg"));

var _silhouetteGirl3 = _interopRequireDefault(require("./assets/silhouette-girl3.svg"));

var _silhouetteGirl4 = _interopRequireDefault(require("./assets/silhouette-girl4.svg"));

var _silhouetteGirl5 = _interopRequireDefault(require("./assets/silhouette-girl5.svg"));

var _silhouetteGuy = _interopRequireDefault(require("./assets/silhouette-guy1.svg"));

var _silhouetteGuy2 = _interopRequireDefault(require("./assets/silhouette-guy2.svg"));

var _silhouetteGuy3 = _interopRequireDefault(require("./assets/silhouette-guy3.svg"));

var _silhouetteGuy4 = _interopRequireDefault(require("./assets/silhouette-guy4.svg"));

var _silhouetteGuy5 = _interopRequireDefault(require("./assets/silhouette-guy5.svg"));

var _sittingService = _interopRequireDefault(require("./assets/sitting-service.svg"));

var _sms = _interopRequireDefault(require("./assets/sms.svg"));

var _star = _interopRequireDefault(require("./assets/star.svg"));

var _stethoscope = _interopRequireDefault(require("./assets/stethoscope.svg"));

var _stethoscopeWhite = _interopRequireDefault(require("./assets/stethoscope-white.svg"));

var _thirtyMinuteWalk = _interopRequireDefault(require("./assets/thirty-minute-walk.svg"));

var _trash = _interopRequireDefault(require("./assets/trash.svg"));

var _twitter = _interopRequireDefault(require("./assets/twitter.svg"));

var _wagLogo = _interopRequireDefault(require("./assets/wag-logo.svg"));

var _wagTag = _interopRequireDefault(require("./assets/wag-tag.svg"));

var _wagTextOnlyLogo = _interopRequireDefault(require("./assets/wag-text-only-logo.svg"));

var _walker = _interopRequireDefault(require("./assets/walker.svg"));

var _walkerSilhouetteGray = _interopRequireDefault(require("./assets/walker-silhouette-gray.svg"));

var _walkService = _interopRequireDefault(require("./assets/walk-service.svg"));

var _weightGray = _interopRequireDefault(require("./assets/weight-gray.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var icons = {
  alert: _alert.default,
  appStore: _appStore.default,
  boardingService: _boardingService.default,
  boneGray: _boneGray.default,
  bulletGreen: _bulletGreen.default,
  calendar: _calendar.default,
  calendarGray: _calendarGray.default,
  calendarGreen: _calendarGreen.default,
  camera: _camera.default,
  car: _car.default,
  carat: _caret.default,
  caratDownGray: _caretDownGray.default,
  caratDownGreen: _caretDownGreen.default,
  caratRightGray: _caretRightGray.default,
  caret: _caret.default,
  caretDownGray: _caretDownGray.default,
  caretDownGreen: _caretDownGreen.default,
  caretRightGray: _caretRightGray.default,
  check: _check.default,
  checkmark: _checkmark.default,
  checkmarkGreen: _checkmarkGreen.default,
  clockGray: _clockGray.default,
  collar: _collar.default,
  creditCard: _creditCard.default,
  daycareService: _daycareService.default,
  default: _dog.default,
  disabledCarat: _caretDisabled.default,
  disabledCaret: _caretDisabled.default,
  disabledCheck: _checkDisabled.default,
  dog: _dog.default,
  dogAvatar: _dogAvatar.default,
  dogFaceGray: _dogFaceGray.default,
  dogGreen: _dogGreen.default,
  dogSilhouetteGray: _dogSilhouetteGray.default,
  dollarSignGray: _dollarSignGray.default,
  email: _email.default,
  envelope: _envelope.default,
  exitGray: _exitGray.default,
  eyeball: _eyeball.default,
  facebook: _facebook.default,
  flyer: _flyer.default,
  googlePlay: _googlePlay.default,
  hamburger: _hamburger.default,
  home: _home.default,
  house: _house.default,
  houseGreen: _houseGreen.default,
  imageGray: _imageGray.default,
  infoGreen: _infoGreen.default,
  infoWhite: _infoWhite.default,
  instagram: _instagram.default,
  key: _key.default,
  lock: _lock.default,
  lockGray: _lockGray.default,
  medicalGray: _medicalGray.default,
  noteGray: _noteGray.default,
  overnightService: _overnightService.default,
  pageNote: _pageNote.default,
  pawPrint: _pawPrint.default,
  pawPrintPinGray: _pawPrintPinGray.default,
  paymentGray: _paymentGray.default,
  pencil: _pencil.default,
  pencilGreen: _pencilGreen.default,
  phone: _phone.default,
  phoneCall: _phoneCall.default,
  plusGreen: _plusGreen.default,
  silhouette: _silhouette.default,
  silhouetteGirl1: _silhouetteGirl.default,
  silhouetteGirl2: _silhouetteGirl2.default,
  silhouetteGirl3: _silhouetteGirl3.default,
  silhouetteGirl4: _silhouetteGirl4.default,
  silhouetteGirl5: _silhouetteGirl5.default,
  silhouetteGuy1: _silhouetteGuy.default,
  silhouetteGuy2: _silhouetteGuy2.default,
  silhouetteGuy3: _silhouetteGuy3.default,
  silhouetteGuy4: _silhouetteGuy4.default,
  silhouetteGuy5: _silhouetteGuy5.default,
  sittingService: _sittingService.default,
  sms: _sms.default,
  star: _star.default,
  stethoscope: _stethoscope.default,
  stethoscopeWhite: _stethoscopeWhite.default,
  thirtyMinuteWalk: _thirtyMinuteWalk.default,
  trash: _trash.default,
  twitter: _twitter.default,
  wagLogo: _wagLogo.default,
  wagTag: _wagTag.default,
  wagTextLogo: _wagTextOnlyLogo.default,
  walker: _walker.default,
  walkerSilhouetteGray: _walkerSilhouetteGray.default,
  walkService: _walkService.default,
  weightGray: _weightGray.default
};
exports.icons = icons;
var _default = icons;
exports.default = _default;